import { ContentfulImage } from "@app/_components/ContentfulImage";
import type {
  BrandPageFragment,
  CategoryPageFragment,
  ContentfulAssetFragment,
  DesignerPageFragment,
} from "@server/gql/graphql";

import { cn } from "@/lib/utils";

export default function FeaturedImageWithBackground({
  data,
  className,
  backgroundImageClassName,
  imageClassName,
}: {
  data: CategoryPageFragment | BrandPageFragment | DesignerPageFragment;
  className?: string;
  backgroundImageClassName?: string;
  imageClassName?: string;
}) {
  const { desktopImage, desktopBackground, mobileImage, mobileBackground } =
    data;
  if (!desktopImage && !desktopBackground && !mobileImage && !mobileBackground)
    return null;
  return (
    <div
      className={cn(
        "relative mt-4 flex items-center justify-center overflow-hidden",
        className,
      )}
    >
      {(desktopBackground || mobileBackground) && (
        <ContentfulImage
          desktopImage={desktopBackground as ContentfulAssetFragment}
          mobileImage={mobileBackground as ContentfulAssetFragment}
          sizes="(max-width: 1920px) 50vw, 60em"
          className={cn("h-full w-full object-cover", backgroundImageClassName)}
        />
      )}
      {(desktopImage || mobileImage) && (
        <ContentfulImage
          desktopImage={desktopImage as ContentfulAssetFragment}
          mobileImage={mobileImage as ContentfulAssetFragment}
          sizes="(max-width: 1920px) 50vw, 60em"
          className={cn(
            "h-auto w-full place-self-center object-cover object-center",
            (desktopBackground || mobileBackground) &&
              "absolute object-contain invert",
            data.type === "Brand" && "max-h-44 max-w-72 object-contain",
            imageClassName,
          )}
        />
      )}
    </div>
  );
}
